import { Navigation } from '../components/Navigation';
import { Benefits } from '../components/Benefits';
import { Testimonial } from '../components/Testimonial';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';

export function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <Benefits />
        <Testimonial />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
